import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { kebabCase } from 'lodash';
import PropTypes from 'prop-types';
import ProductGriditem from './ProductGridItem';
import GridLoading from './GridLoading';
const ProductsGrid = t0 => {
  const $ = _c(9);
  const {
    productsData,
    loading,
    maxCardsCount: t1,
    layout: t2
  } = t0;
  const maxCardsCount = t1 === undefined ? 0 : t1;
  const layout = t2 === undefined ? "" : t2;
  const placeholderCardsCount = maxCardsCount > productsData.length ? maxCardsCount - productsData.length : 0;
  if (loading) {
    let t3;
    if ($[0] !== placeholderCardsCount) {
      t3 = <GridLoading cardsCount={placeholderCardsCount} />;
      $[0] = placeholderCardsCount;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    return t3;
  }
  let t3;
  if ($[2] !== layout || $[3] !== productsData) {
    let t4;
    if ($[5] !== layout) {
      t4 = (productItem, idx) => <ProductGriditem key={`products-grid-item-${kebabCase(productItem.name)}`} productItem={productItem} idx={idx} layout={layout} />;
      $[5] = layout;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = productsData.map(t4);
    $[2] = layout;
    $[3] = productsData;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <>{t3}</>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
ProductsGrid.propTypes = {
  productsData: PropTypes.arrayOf(PropTypes.shape({
    campaign: PropTypes.string,
    enableMobileCarousel: PropTypes.bool,
    filterStateKey: PropTypes.string,
    hidden: PropTypes.bool,
    id: PropTypes.number.isRequired,
    initialOptionId: PropTypes.string,
    isClearance: PropTypes.bool,
    layout: PropTypes.oneOf(['full', 'mini', 'minimal', 'minimal-with-attributes', 'minimal-with-showroom']),
    moreVariantsCount: PropTypes.number,
    name: PropTypes.string,
    onDisplayInShowroomSlug: PropTypes.string,
    path: PropTypes.string,
    position: PropTypes.number,
    productFamily: PropTypes.string,
    productLabel: PropTypes.string,
    productType: PropTypes.string,
    quickship: PropTypes.bool,
    secondaryImage: PropTypes.string,
    secondaryImageCropData: PropTypes.object,
    slug: PropTypes.string,
    variantsToShow: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      image: PropTypes.string,
      isOutOfStock: PropTypes.bool,
      label: PropTypes.string,
      minPrice: PropTypes.number,
      originalPrice: PropTypes.number,
      path: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      quickship: PropTypes.bool,
      sku: PropTypes.string
    })),
    variantsTotal: PropTypes.number
  })),
  loading: PropTypes.bool,
  layout: PropTypes.oneOf(['full', 'mini', 'minimal', 'minimal-with-attributes', 'minimal-with-showroom']),
  maxCardsCount: PropTypes.number
};
export default ProductsGrid;